import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import { history } from '../../routes';
import config from '../../config';

import { ToastContainer, notify } from '../../libraries/notifications';

import { isEmptyObject, getOwner, dateComponents, changeTimeInDate, setTimeZeroDateWithTZ } from '../../libraries/utils';

import purchasesActions from '../../context/purchases/actions';

import LayoutSmall from '../../components/layout/LayoutSmall';
import PharmacyCard from '../../components/customs/PharmacyCard';

import MedicamentCartElement from '../../components/customs/MedicamentCartElement';


class MyPurchase extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
    }
  }
  
  componentDidMount() {
    const params = this.props.match.params;
    if (params.id) {
      this.getPurchase(params.id);
    } else {
      history.push(config.ROUTES.PURCHASES.LIST);
    }
  }

  getPurchase = async (id) => {
    await this.props.onGet(id);
    console.log('AFTER GET');
    const { purchase } = this.props;
    if (purchase.error) { 
      notify(this.t(purchase.error.message));
    } else {
      this.setState({ purchase: purchase.item });
    }
  }

  gotoBack = () => {
    if (this.props.location.state?.root_id) {
      history.push(config.ROUTES.CHAT.replace(':root_id', this.props.location.state?.root_id));
    }else{

      history.push(config.ROUTES.PURCHASES.LIST)
    }
  }  
  
  render(){
    const { purchase } = this.state
    return (
      <LayoutSmall
        main={{ className: "bg-base-200"}}
        header={{
          title: purchase ? purchase.created_at && this.t("timeRemains", { date: new Date(purchase.created_at) }).replace(config.TRANSLATE.TIME_REMAINS,"") : "",
          className: "p-3",
          left: { icon: 'arrow_left', action: () => this.gotoBack() },
        }}
        container={{ className: "px-0"}}
        loading = {this.props.purchase.loading}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          { !this.props.purchase.loading && purchase && purchase.json_data && (
            <div className="mb-10">
                <div className="mb-5">
                  {purchase.json_data.pharmacy && <PharmacyCard
                    purchase={true}
                    pharmacy={purchase.json_data.pharmacy}
                  />}
                </div>
                <div className="flex justify-between mb-4">
                  <h2>{this.t("Pedido")}:</h2>
                  <div className="">
                    {
                      purchase.status === 'open' &&
                      <p className="badge badge-primary">{purchase.json_data?.location ? "Envio pendiente" : "Retiro pendiente"}</p>
                    }
                                      {
                      purchase.status === 'canceled' &&
                      <p className="badge badge-error ">Cancelada</p>
                    }
                                      {
                      purchase.status === 'completed' &&
                      <p className="badge badge-success">Recibida</p>
                    }
                    
                  </div>
                </div>
                {purchase && purchase.json_data.prescription_medicaments.length === 0 && "-"}
                { purchase && purchase.json_data.prescription_medicaments && purchase.json_data.prescription_medicaments.map((medicament, index) =>{ 
                 //const medicament = line.json_data.medicament
                 return(
                    <MedicamentCartElement
                      key={index}
                      className="border-t py-2"
                      medicament={medicament.json_data.medicament}
                    />
                  )
                })}
                <h4>Medicamentos sin prescripcion medica:</h4>
                {purchase && purchase.json_data.medicaments.length === 0 && "-"}
                {purchase && purchase.json_data.medicaments.map((medicament, index) => {
                   return(
                    <MedicamentCartElement
                      key={index}
                      className="border-t py-2"
                      medicament={medicament}
                    />
                  )
                })}
              {purchase.json_data.location ? 
                <>
                  <h4>Dirección:</h4>
                  {purchase.json_data.location.name}
                </> : 
                <>Retiro de farmacia</>
              }
              {purchase.json_data.comments &&
                <>
                  <h4>Comentario:</h4>
                  {purchase.json_data.comments}
                </>
              }
            </div>
          )}
        </section>
      </LayoutSmall>
    )
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,    
    purchase: state.purchases.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGet: (params) => dispatch(purchasesActions.get(params)),
    onSave: (params) => dispatch(purchasesActions.saveOrUpdate(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(MyPurchase));

